export class LinkPasswordData {

    public enc_share_key: string;
    public salt: string;
    public sharekey: ArrayLike<number>;
    public iterations: number;
    public enc_password: string;
    public password?: string;
}
